export default () => ({
  tableWrapper: {
    overflowX: 'auto',
    width: '100%',
  },
  tableContainer: {
    width: '100%',
  },
  tableHead: {
    backgroundColor: '#f5f5f5',
  },
  tableCell: {
    padding: '12px 16px',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
  },
  tr: {
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
});
